<template>
  <a-card size="small">
    <div style="display: flex; align-items: center; gap: 8px">
      <NotificationRuleTag :label="ruleTagLabel" :color="ruleTagColor" />
      <div style="display: flex; flex-direction: column; gap: 4px">
        <a-typography-title :level="5">
          {{ ruleName }}
        </a-typography-title>
        <a-typography-text v-if="emailsText" type="secondary">
          {{ emailsText }}
        </a-typography-text>
      </div>
      <div style="display: flex; margin-left: auto">
        <a-button
          :disabled="props.actionLoading"
          type="link"
          @click="emit('edit', props.rule)"
          :aria-label="`Editar regla de notificación para ${ruleName}`"
        >
          <template #icon>
            <EditOutlined />
          </template>
        </a-button>
        <a-popconfirm
          :title="`¿Seguro que deseas eliminar la regla?`"
          placement="topRight"
          ok-text="Sí"
          cancel-text="No"
          :disabled="props.actionLoading"
          @confirm="emit('delete', props.rule)"
        >
          <a-button
            :disabled="props.actionLoading"
            type="link"
            danger
            :aria-label="`Eliminar regla de notificación para ${ruleName}`"
          >
            <template #icon>
              <DeleteOutlined />
            </template>
          </a-button>
        </a-popconfirm>
      </div>
    </div>
  </a-card>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue';
import NotificationRuleTag from './notification-rule-tag.vue';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons-vue';

const props = defineProps({
  rule: {
    type: Object,
    required: true
  },
  actionLoading: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['delete', 'edit']);

const ruleName = computed(() => {
  const { policy, groupCompany } = props.rule || {};
  if (policy && groupCompany) {
    return `${policy.numberPolicy} - ${groupCompany.name}`;
  } else if (policy) {
    return policy.numberPolicy;
  } else if (groupCompany) {
    return groupCompany.name;
  }
  return 'Global';
});

const ruleTagLabel = computed(() => {
  const { policy, groupCompany } = props.rule || {};
  if (policy && groupCompany) return 'Póliza + Grupo';
  if (policy) return 'Póliza';
  if (groupCompany) return 'Grupo';
  return 'Global';
});

const ruleTagColor = computed(() => {
  const { policy, groupCompany } = props.rule || {};
  if (policy && groupCompany) return 'red';
  if (policy) return 'orange';
  if (groupCompany) return 'green';
  return 'blue';
});

const emailsText = computed(() => {
  const emails = props.rule.emails;
  return emails?.length > 0 ? emails.join(', ') : '';
});
</script>
